import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";

export const ParentGridServices = styled.div `
  width: 100%;
  .currency-container{
    padding-bottom: 30px;
    border-bottom: 1px solid ${Color.greySeparator};
    display: flex;
  }

  .currency-body {
    display: flex;
    flex-direction: row;
    width: 100%;

    ${breakpoints.phone} {
      flex-direction: column;
      background-color: ${Color.greyF5F5F5};
      padding: 0px 15px;
    }
    .currency-content {
      display: flex;
      flex-direction: column;
      width: 180px;

      &.first {
        width: 55%;
        ${breakpoints.phone} {
          display: none;
          width: 100%;
        }
      }

      ${breakpoints.phone} {
        max-height: 70px;
        flex-direction: row;
        justify-content: space-between;
        background-color: ${Color.greyF5F5F5};
        width: 100%;
      }

      p {
        ${Font.sansRegular}
        color: ${Color.grey};
        text-transform: uppercase;
        font-size: 12px;
        line-height: 20px;
        text-align: left;
        padding-left: 15px;
        border-bottom: 1px solid ${Color.greySeparator};
        display: flex;
        align-items: center;
        ${breakpoints.phone} {
          border-bottom: none;
        }

        @media (min-width: 976px) and (max-width: 1360px) {
              font-size: 10px;
              }

        &.value {
          background-color: ${Color.greyF5F5F5};
          ${Font.sansLight}
          line-height: 24px;
          padding: 25px 15px;
          margin-top: 10px;
          max-height: 87px;
          line-height: 24px;
          text-transform: none;
          border-bottom: none;

          &.currency-name {
            font-size: 28px;
            @media (min-width: 976px) and (max-width: 1360px) {
              font-size: 24px;
              }
          }
          &.currency-sale,
          &.currency-buy {
            font-size: 40px;
            @media (min-width: 976px) and (max-width: 1360px) {
              font-size: 33px;
              }
          }
          &.previous-value,
          &.variation-negative,
          &.variation-positive {
            font-size: 25px;
          }
          &.variation-negative {
            color: ${Color.mainColor};
            ${breakpoints.darkMode} {
              [data-theme='dark'] & {
              color: ${ColorDark.mainColor};
              }
            }
          }
          &.variation-positive {
            color: ${Color.negativeCurrency};
          }
        }
      }
    }
  }
  .dotted-border {
    background-image: linear-gradient(
      to bottom,
      #555555 10%,
      rgba(255, 255, 255, 0) 0%
    );
    background-position: left;
    background-size: 1.5px 5.5px;
    background-repeat: repeat-y;

    ${breakpoints.phone} {
      background-image: linear-gradient(
        to right,
        #555555 10%,
        rgba(255, 255, 255, 0) 0%
      );
      background-position: top;
      background-size: 10px 1px;
      background-repeat: repeat-x;

      &.value,
      &.second {
        background-image: none;
      }
    }
  }
`;
export const TitleContainer = styled.div `
  display: flex;
  padding-bottom: 30px;
  padding-top: 10px;

  ${breakpoints.phone} {
    margin-left: 10px;
    padding-bottom: 15px;
    padding-top: 0px;
  }

  .title {
    ${Font.clarinVarSub2Regular}
    color: ${Color.grey};
    font-size: 36px;
    padding-right: 10px;
    line-height: 28px;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      color:${ColorDark.textLight};
      }
    }

    ${breakpoints.phone} {
      font-size: 26px;
    }
  }
  `;

  export const SeoContainer = styled.div `
  display: flex;
  padding-bottom: 30px;
  padding-top: 10px;

  ${breakpoints.phone} {
    margin-left: 10px;
    padding-bottom: 15px;
    padding-top: 0px;
  }

  .subtitle {
    ${Font.sansRegular}
    color: ${Color.grey};
    font-size: 16px;
    padding-right: 10px;
    line-height: 18px;

    ${breakpoints.phone} {
      font-size: 14px;
      line-height: 18px;
    }
  }

`;